import { useState } from "react";
import { CreditCard, Loader2, ShieldCheck, Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { money } from "@/lib/api";

const METHODS = [
  ["ecocash", "EcoCash", Smartphone], ["onemoney", "OneMoney", Smartphone],
  ["visa", "Visa", CreditCard], ["mastercard", "Mastercard", CreditCard],
];

export const PaynowDialog = ({ open, onOpenChange, amount, reference, onPay }) => {
  const [method, setMethod] = useState("ecocash");
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    setBusy(true);
    try {
      await new Promise((r) => setTimeout(r, 1200));
      await onPay(method);
      onOpenChange(false);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="paynow-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Pay with Paynow</DialogTitle>
          <DialogDescription>
            Simulated payment for {reference} — no money will move. Real Paynow can be switched on later.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-xl bg-[#020165] text-white p-4 flex items-center justify-between">
          <span className="text-sm text-white/70">Amount due</span>
          <span className="font-display text-2xl font-extrabold" data-testid="paynow-amount">{money(amount)}</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {METHODS.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setMethod(k)} data-testid={`paynow-method-${k}`}
              className={`flex items-center gap-2 rounded-lg border px-3 py-3 text-sm font-medium transition-colors ${method === k ? "border-[#F86900] bg-[#F86900]/10" : "hover:bg-black/5"}`}>
              <Icon className="h-4 w-4" /> {l}
            </button>
          ))}
        </div>
        <button onClick={pay} disabled={busy} data-testid="paynow-confirm-button"
          className="w-full rounded-full bg-[#F86900] text-[#0D141A] font-bold py-3 flex items-center justify-center gap-2 hover:bg-[#ff7d1f] disabled:opacity-60 transition-colors">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />}
          {busy ? "Processing…" : "Confirm simulated payment"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
